'use client';

import {motion} from 'framer-motion';
import useTopStyle from '../../utils/useTopStyle';
import BookBtn from '../buttons/BookBtn/BookBtn';
import heroVariants from '../../animation/heroVariants';
import spanVariants from '../../animation/spanVariants';
import PlatformAnim from './PlatformAnim/PlatformAnim';

const PlatformHero = () => {
  const ref = useTopStyle(72);

  return (
    <motion.section
      className='platform-hero'
      ref={ref}
      initial={'hidden'}
      animate={'visible'}
      transition={{
        duration: 0.7,
        delay: 0.5,
        ease: 'easeInOut'
      }}
      variants={heroVariants}
    >
      <div className='container'>
        <div className='content'>
          <h2 className='title'>
            Unified monitoring and management
            <span className='arrow-right'></span>
            <motion.span
              className='highlight'
              initial={'hidden'}
              animate={'visible'}
              transition={{
                duration: 0.8,
                delay: 0.8,
                ease: 'easeInOut'
              }}
              variants={spanVariants}
            >
              Simple
            </motion.span>
          </h2>
          <p className='text'>Our integrated platform processes billions of security and operational events every day and reacts to the ones that matter.</p>
          <BookBtn />
        </div>
        <div className='design'>
          <PlatformAnim />
        </div>
      </div>
    </motion.section>
  );
};

export default PlatformHero;

